import { IconButton, Tooltip } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { MouseEvent } from 'react'

interface InfoTooltipProps {
  text: string
}

function InfoTooltip({ text }: InfoTooltipProps) {
  const stop = (e: MouseEvent) => e.stopPropagation()
  return (
    <Tooltip
      title={text}
      arrow
      placement="top"
      enterTouchDelay={0}
      leaveTouchDelay={5000}
      slotProps={{
        tooltip: {
          sx: {
            lineHeight: 1.35,
            fontSize: '0.8125rem',
            maxWidth: 360,
            px: 1.5,
            py: 1,
          },
        },
      }}
    >
      <IconButton
        size="small"
        onClick={stop}
        sx={{ p: 0.25, color: 'text.secondary' }}
        aria-label="Mer informasjon"
      >
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  )
}

export default InfoTooltip
